import * as React from 'react';
import {Card, Collapse, Divider, Typography} from "antd";
import LdapSettingsForm from "@src/components/Settings/LdapSettingsForm";
import SmtpSettingsForm from "@src/components/Settings/SmtpSettingsForm";
import FeedbackSettingsForm from "@src/components/Settings/FeedbackSettingsForm";
import GoogleOAuthSettingsForm from "@src/components/Settings/GoogleOAuthSettingsForm";
import CurrencySettingsForm from "@src/components/Settings/CurrencySettingsForm";
import ChargesSettingsForm from "@src/components/Settings/ChargesSettingsForm";
import SubmissionBuilderSettingsForm from "@src/components/Settings/SubmissionBuilderSettingsForm";
import ServiceCreatorSettingsForm from './ServiceCreatorSettingsForm';
import {customExpandIcon, NotFoundComponent} from "@src/components/Common/utils";
import AIIntegrationSettingsForm from "@src/components/Settings/AIIntegrationSettingsForm";
import GUITableSettingsForm from "@src/components/Settings/GUITableSettingsForm";
import GlobalBannerSettingsForm from "@src/components/Settings/GlobalBannerSettingsForm";
import ExternalAPISettingsForm from "@src/components/Settings/ExternalAPISettingsForm";
import DashboardSettingsForm from './DashboardSettingsForm';


const { Title } = Typography;


const GeneralSettingsList = () => {
    const namesToComp = [
        ["Dashboard Settings", <DashboardSettingsForm/>],
        ["LDAP Settings", <LdapSettingsForm />],
        ["SMTP Settings", <SmtpSettingsForm />],
        ["Feedback Settings", <FeedbackSettingsForm />],
        ["Google OAuth Settings", <GoogleOAuthSettingsForm />],
        ["Currency Settings", <CurrencySettingsForm />],
        ["Charges Settings", <ChargesSettingsForm />],
        ["Submission Builder Settings", <SubmissionBuilderSettingsForm />],
        ["Service Creation Settings", <ServiceCreatorSettingsForm />],
        ["AI Integration Settings", <AIIntegrationSettingsForm />],
        ["GUI Table Settings", <GUITableSettingsForm />],
        ["Global Banner", <GlobalBannerSettingsForm />],
        ["ExternalAPISettings", <ExternalAPISettingsForm />],

    ];

    const user = JSON.parse(localStorage.getItem('user') as string);

    return (
        <Card>
            {
                user?.is_superuser ?
                    <Collapse
                        defaultActiveKey={[]}
                        style={{margin: '10px'}}
                        ghost={true}
                        expandIcon={customExpandIcon}
                        expandIconPosition="start"
                        items={namesToComp.map((subList, outerIndex) => ({
                            key: outerIndex,
                            label: <Title level={4} style={{ margin: 0 }}>{" "}{subList[0]}</Title>,
                            children: (
                                <>
                                    <Card style={{padding: "10px"}}>{subList[1]}</Card>
                                    <Divider style={{ margin: '4px 0' }} />
                                </>
                            ),
                        }))}
                    />
                    :
                    NotFoundComponent
            }
        </Card>
    )
}

export default GeneralSettingsList